import React from 'react';
import { Box, Flex, Icon } from '@chakra-ui/react';
import { BellIcon } from '@chakra-ui/icons'; // Kept BellIcon import
import { MdHome } from 'react-icons/md'; // Import MdHome for a different home icon
import ProfileMenu from '../../components/global/profileMenu';
import { ChakraProvider } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';  // Use useNavigate instead of useHistory

const Header = ({ userName, userEmail, onHomeClick }) => { // Accept onHomeClick as a prop

  return (
    <ChakraProvider>
      <Box bg="#F5F6F8" p={0} boxShadow="md">
        <Flex justify="space-between" align="center">
          {/* Home Icon on the Left */}
          <Box p={2} ml={2} display="flex" alignItems="center"> {/* Added ml={2} for left margin */}
            <Icon as={MdHome} boxSize={6} color="blue.500" cursor="pointer" onClick={onHomeClick} />
          </Box>

          {/* Right Side Icons */}
          <Flex align="center">
            {/* Notification Icon */}
            <Box p={2} display="flex" alignItems="center">
              <Icon as={BellIcon} boxSize={6} color="blue.500" />
            </Box>

            {/* Profile Section */}
            <Box p={2} display="flex" alignItems="center">
              <ProfileMenu name={userName} email={userEmail} />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </ChakraProvider>
  );
};

export default Header;
